export default "__VITE_ASSET__CIfRJFud__"